/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  //outer html fn
  jQuery.fn.outerHTML = function(s) {
    return (s) ? this.before(s).remove() : jQuery('<div>').append(this.eq(0).clone()).html();
  };
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        jQuery.ClearslideJs.init();
        $(document).on('click', '[data-toggle=custom-modal]', function(e){
          e.preventDefault();
          jQuery.ClearslideJs.setModalData({
            content: $($(this).data('target')).html()
          });
          jQuery.ClearslideJs.showModalBox();
          if($(this).data('autoplay') == "true"){

          }
        });
        $('#modalBox').on('show.bs.modal', function (e) {
            // do something...
            if(!!$(this).find('video').length){
              if (typeof player !== 'undefined') {
                // the variable is defined
                player = undefined;
               }
              var player = videojs($('.modal-body video')[0], {
                "controls": true,
                "preload": "auto",
                //"autoplay": $('.modal-body video').data('autoplay'),
                "width": $("#my-video-22").data('width'),
                "playbackRates": [1, 1.5, 2]
              });
              player.ready(function(){
                var myPlayer = this;
                myPlayer.play();
              });
            }
            
        });
        $(document).on('click', '.grid-video-link', function(e){
          e.preventDefault();
          var parentEle = $(this).parents('.vc_grid-item');

          jQuery.ClearslideJs.setModalData({
            content: $('.video-container', parentEle).html()
          });
          jQuery.ClearslideJs.showModalBox();
          if($(this).data('autoplay') == "true"){

          }
        });
        $('.mega-nav-search-icon form label').append('<span class="glyphicon glyphicon-search"></span>');
        $('#searchform .glyphicon-search').on('click', function(){
          $(this).parents('form').submit();
        });

      }

    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS

      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
      finalize: function() {
        jQuery.ClearslideJs.csTeamPopup();
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  //Clearslide scripts
  jQuery.ClearslideJs = {
    init: function(){
      var that = this;
      //this.stickyMenu();
      setTimeout(this.changeGridPlaceholderImage,800);
      setTimeout(this.updateLoadMore, 1500);
     //console.log(document.referrer.split( '/' ));
      this.faqSearch();
      
      $('.related-post-carousel').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3
      });

      $('.glyphicon-question-sign').tooltipster({
         animation: 'fade',
         delay: 200,
         theme: 'tooltipster-punk',
         trigger: 'hover'
      }); //initialize tooltip
      

      this.verticallyAlignMiddle();// vertically align content

      this.matchColsHeight();// equalize col hieight
      setTimeout(function(){
        that.matchColsHeight();
        that.verticallyAlignMiddle();// vertically align content
      },1000);

      this.megaMenuFullWIdthContainer();
      
      this.modalBox(); //init modal Box


      $('.homeslider li>div:first-child').matchHeight();

      var urlSearch = window.location.search.slice(1).split('&&');
      for(i = 0; i< urlSearch.length; i++){
        //console.log(urlSearch[i]);  
        if(urlSearch[i].match('^play=')){
          //console.log(urlSearch[i]);
          var playerId = urlSearch[i].split('=')[1];
          //console.log(playerId);
          setTimeout(function() {
           $('#' + playerId).parents('.hero-video-container').find(".hero-play-icon a" ).trigger('click');
            //console.log('triggerd');
          });
          
        }

      }


    },
    megaMenuFullWIdthContainer: function(){
      //menu fix
      var menu = $('.mega-menu-megamenu > .mega-sub-menu');
      var parent = menu.parent();
      var hg = ((menu.outerHeight()>502)? menu.outerHeight()+"px" : "502px" );
      if($(window).width()>767){
        if(parent.find('.outer-cover').length < 1){
          var newEl = document.createElement('div');
          newEl.setAttribute("class", "outer-cover");
          $(newEl).css({
            "background-color": menu.css('background-color'),
            "height": hg,
            "margin-top": menu.css("margin-top")
          });

          menu.css('background-color', 'transparent'); 
          $(newEl).insertBefore(menu);
        }else{
          hg = ((menu.outerHeight()>502)? menu.outerHeight()+"px" : "502px" );
          //console.log(hg);
          var outerCover = $('.outer-cover', parent);
          outerCover.css({
            'height': hg,
            "margin-top": menu.css("margin-top")
          });
        }
      }else{
        menu.css('background-color', $('.outer-cover', parent).css('background-color')); 
        $('.outer-cover', parent).remove();
      }
      
    },
    faqSearch: function(){
      $('#faq-search').on("keyup", function(e) {
       var searchKey = $(this).val();
       var tabContents = $('.faq-tabs .vc_tta-panels-container .vc_tta-panel .wpb_column');
       var count= 0;
       tabContents.filter(function(index){
          //console.log($(this).text());
          var pattern = new RegExp(''+searchKey+'', 'ig');
          //console.loadEventsg(pattern);
          var tx = $(this).text().replace(/\n/g, " ");
          //console.log(  );
          //console.log(pattern);
          if( tx.match(pattern) ){
            count+=1;
            $(this).removeClass('hidden');
          }else{
            $(this).addClass('hidden');
          }
          //console.log(count);
        });
        
      });
    },
    stickyMenu: function(){
      var  mn = $(".header-wrapper");
       mns = "sticky-menu";
       hdr = mn.height();
       mp = mn.height();//mn.offset().top;
      var stickyCheck = function() {
        if( $(this).scrollTop() > (mp) ) {
          mn.addClass(mns);
        } else {
          mn.removeClass(mns);
        }
      };

      stickyCheck();
      $(window).scroll(stickyCheck);
    },

    changeGridPlaceholderImage: function(){
      var el = $(".vc_grid-item-mini .image-block");
      //console.log(el.css("background-image"));
      $.each(el, function(i, v){
        var imgUl= $(el[i]).css("background-image");
        if( imgUl.indexOf('/vc_gitem_image.png') > 0 ){
          $(el[i]).css("background-image", "");
        }
      });
      
    },
    //vc fix update load more button
    updateLoadMore: function(){
      $('.vc_pageable-load-more-btn a').addClass('btn btn-default').html("See more");
    },

    //vertically align middle any content
    verticallyAlignMiddle: function(){
      var elm = ($('.align-vertically').has('.vc_column-inner').length > 0 )? $('.vc_column-inner', $('.align-vertically')) : $('.align-vertically') ;
      //console.log(elm);
      
      var marginHeight;
      
      $.each(elm, function( index, value ){
        
        imageLoaded = false;
        var parentElm = ($(value).parents('.align-vertically').length > 0 )? $(value).parents('.align-vertically').parent() : $(value).parent();
        
        if(parentElm.has('img').length > 0 && imageLoaded === false){
         //console.log("yes image");

          var im = $('img', parentElm);
          //console.log(im.attr('alt')+ " : "+im.height());

          if (im.complete || /*for IE 10-*/ im.height() > 0) {
              //console.log("image loaded");
              //console.log(im.height());
               marginHeight = parentElm.height()-$(value).height();
               imageLoaded = true;
               if(marginHeight/2 > 0){
                  $(value).css({
                  'top': marginHeight/2 +"px",
                  //'margin-top': marginHeight/2 +"px",
                  //'margin-bottom': marginHeight/2+"px"
                });
               }
              
          }
          else {
              $(im).on('load', function(){
                    imageLoaded = true;
                   marginHeight = parentElm.height()-$(value).height();
                  //console.log(marginHeight);
                  if(marginHeight/2 > 0){
                  $(value).css({
                    'top': marginHeight/2 +"px",
                    //'margin-top': marginHeight/2 +"px",
                    //'margin-bottom': marginHeight/2+"px"
                  });
                 }
              });
          }
        }
        else{
          //console.log("no-image");
           marginHeight = parentElm.height()-$(value).height();
         //console.log("no image");
         //console.log($(value).height());
         //console.log(marginHeight);
          if(marginHeight/2 > 0){
            $(value).css({
            'top': marginHeight/2 +"px",
            //'margin-top': marginHeight/2 +"px",
            //'margin-bottom': marginHeight/2+"px"
          });
         }
        }
        
      });

    },

    matchColsHeight: function(){
      var elParent = $('.match-height-container'); //parent class which child need to be equal height
      
      $.each(elParent, function(i,v){
        var el = $('.match-height', $(this));
        el.matchHeight({
              byRow: false,
              property: 'height'
          });
      });

    },

    modalBox: function(){
      var elm = $('.modal-box');
      var that = this;

      if(elm.hasClass('wpb_single_image')){
        elm = $('a', elm);
        elm.on('click', function(e){
          e.preventDefault();
          var current = this;
          //console.log($(this).attr('href'));
          $("<img/>").attr("src", $(current).attr('href')).load(function() {
              var pic_real_width = (this.width > $(window).width() )? $(window).width() : this.width ;   // Note: $(this).width() will not
              var pic_real_height = this.height; // work for in memory images.
              $('#modalBox img').css({
                width: pic_real_width+"px",
                //height: pic_real_height+"px"
              });
          });
          that.setModalData({
            content: '<img src="'+$(this).attr('href')+'" >',
            class: 'image-modal'
          });
          that.showModalBox();
        });
      }

      $('#modalBox').on('hidden.bs.modal', function (e) { //remove modal data on modal close
        that.removeModalData();
      });
    },
    setModalData: function(modalData){
      var modalContainer = $('#modalBox');
      var data = $.extend({
        title: "",
        content: "",
        footer: "",
        class:"",
      }, modalData);
      //console.log(data);
      if(!!data.title)
        modalContainer.find('.modal-header #modalBoxLabel').html(data.title);
      else
        modalContainer.find('.modal-header').addClass('hidden');
      if(!!data.content)
        modalContainer.find('.modal-body').html(data.content);
      if(!!data.footer)
        modalContainer.find('.modal-footer').html(data.footer);
      else
        modalContainer.find('.modal-footer').addClass('hidden');

       modalContainer.find('.modal-dialog').attr('class', '').addClass('modal-dialog');
      if(!!data.class)
        modalContainer.find('.modal-dialog').addClass(data.class);
    },
    removeModalData: function(){
      //console.log("removing data");
      var modalContainer = $('#modalBox');
      modalContainer.find('.modal-header #modalBoxLabel').html('');
      modalContainer.find('.modal-header').removeClass('hidden');
      modalContainer.find('.modal-body').removeClass('hidden').html('');
      modalContainer.find('.modal-footer').removeClass('hidden').html('');
    },
    showModalBox: function(){
      $('#modalBox').modal();
    },
    csTeamPopup: function(){ //for team bio popup and carousel
      $(document).on('click', '.team-grid .popup-btn button', function(){
           
        var activeEle = $(this).parents('.vc_grid_filter-item');
        var content = $(this).parents('.vc_gitem-animated-block').next().find('.vc_gitem-zone-mini > div:nth-child(2)').outerHTML();
        //popup.open( content.replace("&nbsp;", "<br><br>"), 'html', $('a.popup'));
        var prevLink = "<a href='#prev' class='prev'><i class='fa fa-arrow-left' aria-hidden='true'></i></a>";
        var nextLink = "<a href='#next' class='next'><i class='fa fa-arrow-right' aria-hidden='true'></i></a>";
        if(!!!activeEle.prev()[0])
          prevLink = "<a href='#prev' style='visibility: hidden;' class='prev'><i class='fa fa-arrow-left' aria-hidden='true'></i></a>";
        if(!!!activeEle.next()[0])
          nextLink = "<a href='#next' style='visibility: hidden;' class='next'><i class='fa fa-arrow-right' aria-hidden='true'></i></a>";
        jQuery.ClearslideJs.setModalData({
          class: 'bio-modal',
          content: content.replace("&nbsp;", "<br><br>"),
          footer: "<div class='team-nav text-right'>"+prevLink+nextLink+"</div>"
        });
        jQuery.ClearslideJs.showModalBox();

        /*---------------------
          NEXT & PREVIOUS LINKS
        */
        $(document).on('click', '.bio-modal [href="#next"], .bio-modal [href="#prev"]', function(e){
          e.preventDefault();
          //console.log($(this).attr('href'));

          if($(this).attr('href') == "#prev"){
             content = activeEle.prev().find('.vc_gitem-zone-mini > div:nth-child(2)').outerHTML();
            activeEle = activeEle.prev();
            //console.log(activeEle);
          }
          else if($(this).attr('href') == "#next"){
             content = activeEle.next().find('.vc_gitem-zone-mini > div:nth-child(2)').outerHTML();
            activeEle = activeEle.next();
          }
          //console.log(!!activeEle.next()[0]);
          var prevLink = "<a href='#prev' class='prev'><i class='fa fa-arrow-left' aria-hidden='true'></i></a>";
          var nextLink = "<a href='#next' class='next'><i class='fa fa-arrow-right' aria-hidden='true'></i></a>";
          if(!!!activeEle.prev()[0])
            prevLink = "<a href='#prev' style='visibility: hidden;' class='prev'><i class='fa fa-arrow-left' aria-hidden='true'></i></a>";
          if(!!!activeEle.next()[0])
            nextLink = "<a href='#next' style='visibility: hidden;' class='next'><i class='fa fa-arrow-right' aria-hidden='true'></i></a>";
          $('.bio-modal .modal-body > div').addClass('fade-effect fade-out');
          jQuery.ClearslideJs.setModalData({
            class: 'bio-modal',
            content: $(content.replace("&nbsp;", "<br><br>")).fadeIn('400'),
            footer: "<div class='team-nav text-right'>"+prevLink+nextLink+"</div>"
          }); 
        });
      });
    },
    isRetina: function(){
      return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches)) || (window.devicePixelRatio && window.devicePixelRatio >= 2));
    }
  };
  $(window).load(function(){
    //console.log("window loaded");
    //ClearslideJs.verticallyAlignMiddle();

  });
  $(window).resize(function(){
    //console.log("window loaded");
    jQuery.ClearslideJs.verticallyAlignMiddle();
    jQuery.ClearslideJs.megaMenuFullWIdthContainer();

  });

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
